//src/pages/CarDetail/UserListing.js
import React from "react";
import { useParams } from "react-router-dom";
import Listcaruser from "../../../components/pages/profile/Listcaruser";
import { useUserListing } from "../../../hooks/pages/property/useUserListing";

export default function UserListing() {
  const { id } = useParams();

  const {
    cars, pagination, loading, error,
    page, setPage,
    filters, handleInputChange,
  } = useUserListing(id);

  const userInfo = cars[0]?.user;

    if (loading) return <div className="p-6 text-center">Đang tải danh sách xe...</div>;
    if (error) return <div className="p-6 text-red-600 text-center">Lỗi: {error}</div>;

    return (
        <div className="max-w-6xl mx-auto p-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Danh sách xe của người dùng</h2>

            {userInfo && (
                <div className="bg-white p-6 rounded shadow-md mb-6 flex items-center gap-6">
                    <div className="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center text-xl font-bold text-gray-600">
                        {userInfo.name?.charAt(0).toUpperCase()}
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold text-gray-800">{userInfo.name}</h3>
                        <p className="text-gray-600">📧 {userInfo.email}</p>
                        <p className="text-gray-600">📞 {userInfo.phone}</p>
                    </div>
                </div>
            )}

            {/* Bộ lọc đơn giản */}
            <div className="flex flex-wrap gap-4 mb-4">
                <input
                    type="text"
                    name="brand"
                    placeholder="Hãng xe (brand)"
                    value={filters.brand}
                    onChange={handleInputChange}
                    className="border p-2 rounded w-40"
                />
                <input
                    type="text"
                    name="model"
                    placeholder="Dòng xe (model)"
                    value={filters.model}
                    onChange={handleInputChange}
                    className="border p-2 rounded w-40"
                />
                <input
                    type="number"
                    name="year"
                    placeholder="Năm sản xuất (year)"
                    value={filters.year}
                    onChange={handleInputChange}
                    className="border p-2 rounded w-40"
                />
            </div>

            {cars.length === 0 ? (
                <p className="text-gray-500">Không tìm thấy xe phù hợp.</p>
            ) : (
                <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        {cars.map((car) => (
                            <Listcaruser key={car.id} car={car} />
                        ))}
                    </div>

                    {/* Pagination */}
                    <div className="flex justify-center items-center gap-4 mt-6">
                        <button
                            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                            disabled={page <= 1}
                            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                        >
                            Trang trước
                        </button>
                        <span>
                            Trang {pagination.page} / {pagination.totalPages}
                        </span>
                        <button
                            onClick={() => setPage((prev) => prev + 1)}
                            disabled={page >= pagination.totalPages}
                            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                        >
                            Trang sau
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
